/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Yhonaiker Moncada <ymoncada@technisupport.com>

 * @version 2.0
 */

function formaterCant (amount = 0) {
  const parts = amount?.toString().split(",");
  parts[0] = parts[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts?.join(",");
}

// Precisión más alta en uso: más dígitos decimales indican un valor crudo de la base, no uno ya formateado.
const MAX_DISPLAY_PRECISION = 7;

const __formaterCant = (amount = 0) => {
  const parts = amount.toString().split(".");
  const isRawZeroDecimals =
    parts.length > 1 && parseInt(parts[1]) === 0 && parts[1].length > MAX_DISPLAY_PRECISION;
  if (parts.length === 1 || isRawZeroDecimals) {
    // Si no hay parte decimal o es cero, devuelve solo la parte entera
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    // Si hay parte decimal, devuelve el número formateado con ambas partes
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
};

function formatearNumero (numero, minimumFractionDigits) {
  const opciones = {
    style: "decimal",
    minimumFractionDigits
  };

  const formatoNumero = new Intl.NumberFormat("es-ES", opciones);
  return formatoNumero.format(numero);
}

export { formaterCant, __formaterCant, formatearNumero };
